import * as yup from 'yup';

const basicInfoSchema = () =>
  yup.object().shape({
    title: yup
      .object()
      .shape({
        label: yup.string(),
        value: yup.string(),
      })
      .nullable(),
    company: yup
      .object()
      .shape({
        label: yup.string(),
        value: yup.string(),
      })
      .nullable(),
    oneLineBio: yup.string().max(40, 'Must be 40 characters or less').nullable(),
    enablePublicProfile: yup.boolean(),
  });

export default basicInfoSchema;
